var buttonClickOnce = {
    init: function () {
        const buttons = document.querySelectorAll(".js-click-once");
        const clickStopper = (e) => { e.preventDefault() };
        if (buttons) {
            // prevents focus style on click
            buttons.forEach(el => el.addEventListener('click', (e) => { el.addEventListener("click", clickStopper) }));
        }
    }
}

export default buttonClickOnce;